import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-selector',
  templateUrl: './map-selector.component.html',
  styleUrls: ['./map-selector.component.scss']
})
export class MapSelectorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
